import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Star, LogIn, ArrowLeft } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/admin/dashboard");
  }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <a href="/" className="inline-flex items-center gap-2 text-zinc-500 hover:text-white text-sm mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" /> Voltar ao site
        </a>
        <div className="border border-white/12 bg-[#0e0e0e] rounded-sm p-8">
          <div className="flex items-center gap-2 mb-6">
            <Star className="w-6 h-6 text-gold fill-gold" />
            <span className="font-heading font-600 text-white text-lg">PAINEL ADMINISTRATIVO</span>
          </div>
          <p className="text-zinc-400 text-sm leading-relaxed mb-8">
            Acesso restrito ao administrador do site. Faça login com a sua conta Google autorizada para editar planos, preços, fotos, depoimentos, unidades e textos.
          </p>
          <button
            onClick={login}
            data-testid="admin-google-login"
            className="w-full inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-hover text-black font-heading font-600 tracking-wide px-6 py-4 rounded-sm transition-colors"
          >
            <LogIn className="w-5 h-5" /> ENTRAR COM GOOGLE
          </button>
        </div>
      </div>
    </div>
  );
}
